module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-detail"
  }, [_c('app-header', {
    staticClass: "header"
  }), _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), (_vm.safetyConfirmationId && _vm.safetyConfirmationId > 0) ? [_c('li', [_c('router-link', {
    attrs: {
      "to": "/safety_confirmations"
    }
  }, [_vm._v(_vm._s(_vm.$t('Safety Confirmation List')))])], 1), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.goSafetyConfirmationAnswerList()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Safety Confirmation Answer List')))])])] : [_c('li', [_c('router-link', {
    attrs: {
      "to": "/users"
    }
  }, [_vm._v(_vm._s(_vm.$t('User List')))])], 1)], _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('User Detail')))])])], 2), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.search(false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('user_list.employee')))])])])])]), (_vm.user != null && !_vm.loading && _vm.callbackflg && _vm.stepUpEnd) ? _c('div', [_c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-sm-12 text-right"
  }, [(_vm.isSystemManagement || ((_vm.isAppIncluding || _vm.isAppNotIncluded) && _vm.localShopId == _vm.user.attributes['shop-id'])) ? _c('a', {
    staticClass: "btn btn-warning",
    staticStyle: {
      "margin-right": "5px"
    },
    on: {
      "click": function($event) {
        _vm.onClickPdf(_vm.user.id)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file"
  }), _c('span', [_vm._v("名簿印刷")])]) : _vm._e(), (_vm.isSystemManagement || _vm.isHumanStaffLocal) ? _c('a', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        _vm.csvDownload()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Csv Download')))])]) : _vm._e()])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-sm-6 text-center"
  }, [_c('div', {
    staticClass: "box text-center"
  }, [(!_vm.isBrowsIncluding) ? _c('p', [_c('img', {
    staticClass: "img-rounded",
    staticStyle: {
      "width": "auto",
      "max-height": "200px"
    },
    attrs: {
      "src": _vm.user.attributes['avartar-path'] + '?token=' + _vm.authToken + '&timestamp=' + _vm.timeStamp
    },
    on: {
      "click": function($event) {
        _vm.onClickImageModalShow(_vm.user)
      }
    }
  })]) : _vm._e(), _c('h4', [_vm._v(_vm._s(_vm.user.attributes['user-name']) + "　" + _vm._s(_vm.user.attributes['user-firstname'])), _c('br'), _vm._v("（" + _vm._s(_vm.user.attributes['user-name-furigana']) + " " + _vm._s(_vm.user.attributes['user-firstname-furigana']) + "）")]), _c('p', {
    staticClass: "profile"
  }, [_vm._v("社員番号 : " + _vm._s(_vm.user.attributes['code']))]), (_vm.isSystemManagement || _vm.isAppIncluding || (_vm.isAppNotIncluded && _vm.localShopId == _vm.user.attributes['shop-id'])) ? _c('p', {
    staticClass: "profile"
  }, [_vm._v("性別 : " + _vm._s(_vm.user.attributes['sex'])), _c('br'), _vm._v("生年月日 : " + _vm._s(_vm.user.attributes['user-birthday-format'])), _c('br'), _vm._v("年齢 : " + _vm._s(_vm.user.attributes['age']) + " 歳")]) : _c('p', {
    staticClass: "profile"
  }, [_vm._v("性別 : " + _vm._s(_vm.user.attributes['sex'])), _c('br'), _vm._v("誕生日 : " + _vm._s(_vm.user.attributes['user-birthday-format'].slice(5)))])])]), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [(!_vm.isBrowsIncluding) ? _c('label', {
    staticClass: "control-label"
  }, [_vm._v("ＩＤ")]) : _vm._e(), (!_vm.isBrowsIncluding) ? _c('p', [_c('span', [_vm._v(_vm._s(_vm.user.attributes['login-id']))])]) : _vm._e(), (!_vm.isBrowsIncluding) ? _c('hr') : _vm._e(), _c('label', {
    staticClass: "control-label"
  }, [_vm._v("社員番号")]), _c('p', [_c('span', [_vm._v(_vm._s(_vm.user.attributes['code']))])]), _c('hr'), _c('label', {
    staticClass: "control-label"
  }, [_vm._v("所属店舗")]), _c('p', [_c('span', [_vm._v(_vm._s(_vm.user.attributes['shop-name']))])]), _c('hr'), _c('label', {
    staticClass: "control-label"
  }, [_vm._v("役職")]), _c('p', [_c('span', [_vm._v(_vm._s(_vm.user.attributes['user-type-name']))])]), _c('hr'), _c('label', {
    staticClass: "control-label"
  }, [_vm._v("入社日")]), _c('p', [_c('span', [_vm._v(_vm._s(_vm.user.attributes['user-joinday-format']))])]), _c('label', {
    staticClass: "control-label"
  }, [_vm._v("入社経緯")]), _c('p', [_c('span', [_vm._v(_vm._s(_vm.user.attributes['join-class']))])]), (_vm.afterOver) ? _c('label', {
    staticClass: "control-label"
  }, [_vm._v("離職日")]) : _vm._e(), (_vm.afterOver) ? _c('p', [_c('span', [_vm._v(_vm._s(_vm.user.attributes['user-overday-format']))])]) : _vm._e(), (_vm.beforeOver) ? _c('label', {
    staticClass: "control-label"
  }, [_vm._v("離職予約日")]) : _vm._e(), (_vm.beforeOver) ? _c('p', [_c('span', [_vm._v(_vm._s(_vm.user.attributes['user-overday-format']))])]) : _vm._e()])])]), (_vm.isSystemManagement || _vm.isAppIncluding || (_vm.isAppNotIncluded && _vm.localShopId == _vm.user.attributes['shop-id'])) ? _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 margin-top"
  }, [_c('table', {
    staticClass: "table table-bordered table-color"
  }, [_c('tbody', [(_vm.afterOver || _vm.beforeOver) ? _c('tr', [_c('th', {
    staticClass: "col-sm-5"
  }, [_vm._v("離職区分")]), _c('td', {
    staticClass: "col-sm-7"
  }, [_vm._v(_vm._s(_vm.user.attributes['turnover-class']))])]) : _vm._e(), (_vm.afterOver || _vm.beforeOver) ? _c('tr', [_c('th', {
    staticClass: "col-sm-5"
  }, [_vm._v("離職事由")]), _c('td', {
    staticClass: "col-sm-7"
  }, [_vm._v(_vm._s(_vm.user.attributes['turnover-content']))])]) : _vm._e(), (_vm.afterOver || _vm.beforeOver) ? _c('tr', [_c('th', {
    staticClass: "col-sm-5"
  }, [_vm._v("離職事由補記")]), _c('td', {
    staticClass: "col-sm-7",
    domProps: {
      "innerHTML": _vm._s(_vm.overRemark)
    }
  })]) : _vm._e(), _c('tr', [_c('th', {
    staticClass: "col-sm-5"
  }, [_vm._v("住所")]), _c('td', {
    staticClass: "col-sm-7"
  }, [_vm._v("〒" + _vm._s(_vm.postFirst) + "-" + _vm._s(_vm.postLast) + "　" + _vm._s(_vm.user.attributes['user-address']))])]), _c('tr', [_c('th', {
    staticClass: "col-sm-5"
  }, [_vm._v("携帯番号")]), _c('td', {
    staticClass: "col-sm-7"
  }, [_c('a', {
    attrs: {
      "href": _vm.telChange(_vm.user.attributes['user-mobile'])
    }
  }, [_vm._v(_vm._s(_vm.user.attributes['user-mobile']))])])]), _c('tr', [_c('th', {
    staticClass: "col-sm-5"
  }, [_vm._v("電話番号")]), _c('td', {
    staticClass: "col-sm-7"
  }, [_c('a', {
    attrs: {
      "href": _vm.telChange(_vm.user.attributes['user-tel'])
    }
  }, [_vm._v(_vm._s(_vm.user.attributes['user-tel']))])])]), _c('tr', [_c('th', {
    staticClass: "col-sm-5"
  }, [_vm._v("メールアドレス")]), _c('td', {
    staticClass: "col-sm-7"
  }, [_vm._v(_vm._s(_vm.user.attributes['email']) + "@" + _vm._s(_vm.user.attributes['user-domain-content']))])]), _c('tr', [_c('th', {
    staticClass: "col-sm-5"
  }, [_vm._v("業務内容詳細")]), _c('td', {
    staticClass: "col-sm-7",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })]), _c('tr', [_c('th', {
    staticClass: "col-sm-5"
  }, [_vm._v("備考")]), _c('td', {
    staticClass: "col-sm-7",
    domProps: {
      "innerHTML": _vm._s(_vm.userMemo)
    }
  })]), _c('tr', [_c('th', {
    staticClass: "col-sm-5"
  }, [_vm._v("個人メモ")]), _c('td', {
    staticClass: "col-sm-7",
    domProps: {
      "innerHTML": _vm._s(_vm.remark)
    }
  })]), _c('tr', [_c('th', {
    staticClass: "col-sm-5"
  }, [_vm._v("運転免許証期限日")]), _c('td', {
    staticClass: "col-sm-7"
  }, [_vm._v(_vm._s(_vm.user.attributes['user-license-file-date-format']))])]), _c('tr', [_c('th', {
    staticClass: "col-sm-5"
  }, [_vm._v("任意保険証期限日")]), _c('td', {
    staticClass: "col-sm-7"
  }, [_vm._v(_vm._s(_vm.user.attributes['user-insurance-file-date-format']))])]), _c('tr', [_c('th', {
    staticClass: "col-sm-5"
  }, [_vm._v("車検証期限日")]), _c('td', {
    staticClass: "col-sm-7"
  }, [_vm._v(_vm._s(_vm.user.attributes['user-car-file-date-format']))])]), _c('tr', [_c('th', {
    staticClass: "col-sm-5"
  }, [_vm._v("身元保証書・保証人住民票・印鑑登録証明書・保証人確認票期限日")]), _c('td', {
    staticClass: "col-sm-7"
  }, [_vm._v(_vm._s(_vm.user.attributes['user-background-file-date-format']))])])])])])])])]) : _vm._e(), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('span', [_vm._v("最終更新日:" + _vm._s(_vm.user.attributes['updated-at-format']))])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-8 text-left"
  }, [((_vm.isSystemManagement || ((_vm.isAppIncluding || _vm.isAppNotIncluded) && _vm.localShopId == _vm.user.attributes['shop-id'])) && !_vm.afterOver) ? _c('a', {
    staticClass: "btn btn-success",
    class: {
      disabled: _vm.beforeOver
    },
    staticStyle: {
      "margin-right": "5px"
    },
    on: {
      "click": function($event) {
        _vm.goUserOver(_vm.user.id)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-group"
  }), _c('span', [_vm._v("離職登録")])]) : _vm._e(), _c('a', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-right": "5px"
    },
    on: {
      "click": function($event) {
        _vm.goUserHistory(_vm.user.id)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-history"
  }), _c('span', [_vm._v("履歴確認")])]), (_vm.userServiceQuestionId) ? _c('a', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-right": "5px"
    },
    on: {
      "click": function($event) {
        _vm.goServiceAnswer(_vm.user.id)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _c('span', [_vm._v("接客評価")])]) : _vm._e(), ((_vm.isSystemManagement || _vm.isHumanStaffLocal || ((_vm.isAppIncluding || _vm.isAppNotIncluded) && _vm.localShopId == _vm.user.attributes['shop-id']))) ? _c('a', {
    staticClass: "btn btn-warning",
    staticStyle: {
      "margin-right": "15px"
    },
    on: {
      "click": function($event) {
        _vm.goUserPdf(_vm.user.id)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  }), _c('span', [_vm._v("書類保存")])]) : _vm._e(), ((_vm.isSystemManagement || ((_vm.isAppIncluding || _vm.isAppNotIncluded) && _vm.localShopId == _vm.user.attributes['shop-id'])) && !_vm.afterOver) ? _c('a', {
    staticClass: "btn btn-info",
    staticStyle: {
      "margin-right": "5px"
    },
    on: {
      "click": function($event) {
        _vm.goUserEdit(_vm.user.id)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  }), _c('span', [_vm._v("編集")])]) : _vm._e(), ((_vm.isSystemManagement || (_vm.isAppIncluding && _vm.localShopId == _vm.user.attributes['shop-id'])) && !_vm.afterOver) ? _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.userDelete
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-o"
  }), _c('span', [_vm._v("削除")])]) : _vm._e()]), _c('div', {
    staticClass: "col-xs-4 text-right"
  }, [((_vm.afterOver || _vm.beforeOver) && _vm.isSystemManagement) ? _c('a', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "margin-right": "5px"
    },
    on: {
      "click": _vm.retireCancel
    }
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _c('span', [_vm._v("退職取消")])]) : _vm._e(), _c('a', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.goBackList
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  }), _c('span', [_vm._v("戻る")])])]), _vm._m(0)])]) : _vm._e(), _c('button', {
    staticClass: "hide",
    attrs: {
      "id": "imageModalButton",
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#imageModal"
    }
  }, [_vm._v("モーダル発火用")]), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "imageModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modalcenter"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(1), _c('div', {
    staticClass: "modal-img_footer text-center"
  }, [_c('p', {
    attrs: {
      "id": "imageModalText"
    }
  }), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('Close')))])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "id": "pdf_detail_download",
      "action": "",
      "method": "post",
      "target": "pdf"
    }
  }, [_c('input', {
    attrs: {
      "id": "token",
      "type": "hidden",
      "name": "token",
      "value": ""
    }
  }), _c('input', {
    attrs: {
      "id": "download_id",
      "type": "hidden",
      "name": "download_id",
      "value": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "id": "imageModalImg",
      "src": "",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-210c175c!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/user-detail.pug
// module id = 783
// module chunks = 1